import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { Transition, TransitionGroup } from 'react-transition-group'
import { removeNotice } from '~redux/notices'

class Notices extends React.Component {
  constructor (props) {
    super(props)

    this.timeouts = {}

    this.transitionStyles = {
      entering: 'transition ease-out duration-100 transform opacity-0 scale-95',
      entered: 'transition ease-out duration-100 transform opacity-100 scale-100',
      exiting: 'transition ease-in duration-75 transform opacity-100 scale-100',
      exited: 'transition ease-in duration-75 transform opacity-0 scale-95'
    }
  }

  render () {
    this.props.notices.forEach(notice => {
      if (this.timeouts[notice.id] === undefined) {
        this.timeouts[notice.id] = setTimeout(() => {
          this.props.removeNotice(notice.id)
          delete this.timeouts[notice.id]
        }, 5000)
      }
    })

    return (
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 flex flex-col origin-top-left fixed z-10 top-0 left-0 w-full">
        <TransitionGroup>
          {this.props.notices.map(notice => (
            <Transition timeout={100} key={notice.id}>
              {state => (
                <div className={classNames('mt-2 px-4 py-2 rounded-md shadow-lg text-white', notice.type === 'error' ? 'bg-red-500' : 'bg-green-500', this.transitionStyles[state])}>
                  {notice.text}
                </div>
              )}
            </Transition>
          ))}
        </TransitionGroup>
      </div>
    )
  }
}

Notices.propTypes = {
  notices: PropTypes.array,
  removeNotice: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    notices: state.notices
  }
}

const mapDispatchToProps = { removeNotice }

export default connect(mapStateToProps, mapDispatchToProps)(Notices)
